<script lang="ts" setup>
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import RoomieCardLink from '@lahaus-roomie/roomie/src/components/RoomieCardLink/index.vue'
import type { Option, Props } from './types'
import './_index.scss'

defineProps<Props>()
const { t, rt, tm } = useI18n()
const emit = defineEmits(['submit', 'skip'])

const options = tm('options') as Array<Option>

const handleOptionClick = (value: string) => {
  emit('submit', { name: 'opportunityType', value })
}

const handleSkip = () => {
  emit('skip', { name: 'opportunityType', value: null })
}
</script>

<script lang="ts">
export default {
  name: 'OnboardingStepsOpportunityType'
}
</script>

<template>
  <section class="onboarding-steps-opportunity-type">
    <h2 class="text-carbon-800 text-20 font-semibold mb-8 text-center">
      {{ t('title') }}
    </h2>

    <div class="onboarding-steps-opportunity-type__options">
      <RoomieCardLink
        v-for="(option, index) in options"
        :id="`opportunity-type-option-${index}`"
        :key="`opportunity-type-option-${index}`"
        :data-lh-id="`onboarding-opportunity-type-option-${index}`"
        class="cursor-pointer"
        container-tag="div"
        :title="rt(option.label)"
        :icon-name="rt(option.icon)"
        :interactive="true"
        :can-right-arrow="true"
        @click="() => handleOptionClick(rt(option.value))" />
    </div>

    <div class="w-full mt-12 flex justify-center">
      <RoomieButton
        id="onboarding-steps-opportunity-type-skip-button"
        data-lh-id="onboarding-steps-opportunity-type-skip-button"
        type="button"
        :aria-label="t('skipCta')"
        variant="ghost"
        @click="handleSkip">
        {{ t('skipCta') }}
      </RoomieButton>
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
